import { normalizarData, normalizarValor } from '../../utils/index';

/**
 * Retorna TRUE se o array de dados se parecer com
 * um arquivo de Comprovante de Pagamentos da Sipag.
 */
export const detectar = (dadosArray) => {
    for (let i = 0; i < Math.min(dadosArray.length, 10); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;

        // Limpeza básica para lowercase, mantendo a string original para casos sem formatação bizarra
        const cleanRow = linha.map(c => String(c || '').trim().toLowerCase());
        
        const hasDataPagamento = cleanRow.some(c => c.includes('data do pagamento'));
        const hasBandeira = cleanRow.some(c => c.includes('bandeira'));
        const hasProduto = cleanRow.some(c => c.includes('produto'));

        // Sipag identifica fortemente por ter "Data do pagamento", "Bandeira" e "Produto"
        if (hasDataPagamento && hasBandeira && hasProduto) {
            return true;
        }
    }
    return false;
};

/**
 * Processa a planilha bruta e retorna array mapeado.
 */
export const processar = (dadosArray) => {
    let idxCabecalho = -1;
    let idxData = -1;
    let idxValorLiquido = -1;
    let idxProduto = -1;

    // 1. Encontrar a linha de cabeçalho
    for (let i = 0; i < Math.min(dadosArray.length, 10); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;

        const cleanRow = linha.map(c => String(c || '').trim().toLowerCase());
        
        const possibleDataIdx = cleanRow.findIndex(c => c.includes('data do pagamento'));
        // Busca agnóstica: "Valor líquido" pode sofrer corrupção de acento.
        // Solução: Procurar o padrão "valor l" (com espaço) ou "quido". Isso ignora o "valor bruto".
        const possibleValorIdx = cleanRow.findIndex(c => c.includes('valor l') || c.includes('quido'));
        const possibleProdutoIdx = cleanRow.findIndex(c => c.includes('produto') || c.includes('tipo'));

        if (possibleDataIdx !== -1 && possibleValorIdx !== -1) {
            idxCabecalho = i;
            idxData = possibleDataIdx;
            idxValorLiquido = possibleValorIdx;
            idxProduto = possibleProdutoIdx;
            break;
        }
    }

    if (idxCabecalho === -1) {
        throw new Error('Cabeçalho Sipag não encontrado.');
    }

    const repasses = [];
    
    // 2. Processar os dados
    for (let i = idxCabecalho + 1; i < dadosArray.length; i++) {
        const linha = dadosArray[i];
        if (!linha || linha.length === 0) continue;

        // Verificar a primeira coluna para ignorar a linha de "Total" ou linhas vazias
        const col0 = String(linha[0] || '').trim().toLowerCase();
        if (col0 === 'total' || col0 === '') {
            continue; // Pular linha de total ou linhas vazias que podem aparecer no fim
        }

        const dataStr = String(linha[idxData] || '').trim();
        if (!dataStr) continue;

        const data = normalizarData(dataStr);
        let valor = null;

        const valorRaw = String(linha[idxValorLiquido] || '').trim();
        // O Sipag pode trazer o valor como "R$ 961,31" ou "961,31"
        if (valorRaw) {
             valor = normalizarValor(valorRaw);
        }

        let tipoStr = 'Desconhecido';
        if (idxProduto !== -1 && linha[idxProduto]) {
            tipoStr = String(linha[idxProduto]).trim();
        }

        if (data && valor !== null && valor > 0) {
            repasses.push({
                linha: i + 1,
                data: data,
                valor: valor,
                dataOriginal: dataStr,
                tipo: tipoStr
            });
        }
    }

    return repasses;
};
